import { useDatePickerContext } from '../DatePickerContext/DatePickerContext.js';

var useDatePickerModeToggleButton = function (_a) {
    var children = _a.children;
    var _b = useDatePickerContext(), mode = _b.mode, datePickerId = _b.datePickerId, setMode = _b.setMode;
    return {
        props: {
            children: children,
            onClick: function () { return setMode(mode === "year" ? "month" : "year"); },
            "aria-haspopup": true,
            "aria-expanded": mode === "year",
            "aria-controls": "".concat(datePickerId, "-year-list"),
        },
    };
};

export { useDatePickerModeToggleButton };
//# sourceMappingURL=useDatePickerModeToggleButton.js.map
